import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "features container" }
const _hoisted_2 = { class: "features__list" }
const _hoisted_3 = { class: "features__item-icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "features__item-text" }
const _hoisted_7 = { class: "features__item-title" }
const _hoisted_8 = { class: "features__item-description" }

import { ContentStats } from '@/helpers/contentStats'


export default /*@__PURE__*/_defineComponent({
  __name: 'Features',
  setup(__props) {

const blocks = [
  {
    title: 'Save Time & Learn Faster',
    description:
      'Our summaries convey the key points without fluff and without losing important info. You will learn 10x faster.',
    icon: 'save-time',
  },
  {
    title: 'Improve Your Decision Making',
    description:
      'Shortform summaries are designed to be actionable.  Apply the lessons directly to your life.',
    icon: 'decisions',
  },
  {
    title: 'Read More Consistently',
    description:
      '1-page and Full summaries make reading more accessible. You can read a new summary every day.',
    icon: 'read-more',
  },
  {
    title: 'Broaden Your Knowledge',
    description: `We cover dozens of topics across over ${ContentStats.books} book summaries, and add new summaries every week.`,
    icon: 'knowledge',
  },
  {
    title: 'Increase Your Retention',
    description:
      'Ever forget an important fact from a book? Our summaries clearly state key information in plain language.',
    icon: 'retention',
  },
]

function getIcon(icon: string): string {
  return require(`@/assets.app/images/billing/${icon}.svg`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "billing-data__title" }, " Become a Better Leader, Speaker, & Thinker ", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(blocks, (block) => {
        return _createElementVNode("div", {
          key: block.title,
          class: "features__item"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: getIcon(block.icon),
              alt: "icon",
              class: "features__item-icon-image"
            }, null, 8, _hoisted_4),
            _createElementVNode("img", {
              src: getIcon(block.icon + '-dark'),
              alt: "icon",
              class: "features__item-icon-image-night"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(block.title), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(block.description), 1)
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})